import styled from "styled-components";

export const Footer = styled.footer`
  background-color: #090909;
  color: white;
  padding: 20px;
  text-align: center;
  height: 100px;
  ul{ 
    display: flex;
    justify-content: center;
    font-size: .8rem;
    font-family: 'Rubik';
    align-items: center;
    vertical-align: middle;
    padding-top: 20px;
    li{
      margin-left: 50px;
    }
  }
  `;

